export const PaymentNotificationTypeValues = {
    None: 0,
    Broker: 1,
    Client: 2,
    BrokerAndClient: 1 | 2
}

export type PaymentNotificationType = typeof PaymentNotificationTypeValues[keyof typeof PaymentNotificationTypeValues]